import useVideoViewLayout from '$Utilities/hooks/useVideoLayout';
import { LayoutProps } from './VideoViewsLayout';
import { Grid } from 'MaterialUIComponents';
import VideoBox from './VideoBox';
import VideoSecondaryBar from './VideoSecondaryBar';
import { useEffect, useState } from 'react';
import { React } from 'Imports';

const styles = require('./Layouts.scss') as {
    secondaryVideoBarViewBox: string;
};

const DoubleView = (props: LayoutProps) => {
    const [transitionEffect, setTransitionEffect] = useState(false);
    const mainVideoHeight = 360;

    const { mainVideos, secondaryVideos } = useVideoViewLayout(props.videoAssets, props.primaryChannelNumber, 'Double');

    useEffect(() => {
        setTransitionEffect(true);
    }, [props.videoAssets]);

    return (
        <>
            <Grid container gap={'16px'} flexWrap="nowrap">
                {mainVideos.map((video, idx) => (
                    <Grid item xs={6} key={idx}>
                        <VideoBox
                            video={video}
                            transitionEffect={transitionEffect}
                            height={mainVideoHeight}
                            maxHeight={mainVideoHeight}
                            onVideoDownloaded={props.onVideoDownloaded}
                        />
                    </Grid>
                ))}
            </Grid>

            {secondaryVideos.length > 0 && (
                <div>
                    <VideoSecondaryBar
                        videos={secondaryVideos}
                        transitionEffect={transitionEffect}
                        height={143}
                        itemClassName={styles.secondaryVideoBarViewBox}
                        onVideoDownloaded={props.onVideoDownloaded}
                    />
                </div>
            )}
        </>
    );
};

export default DoubleView;
